import { useMutation } from '@tanstack/react-query';

import { $apiV2, errorHandler } from 'modules/global';

export function useCheckTest() {
  return useMutation({
    mutationFn: async ({ testId, optionId }: { testId?: number; optionId?: number | null }) => {
      const { data } = await $apiV2.post(`/dtm/check`, { id: testId, option_id: optionId });

      return data;
    },
    onError: errorHandler()
  });
}
